var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68432 12.4686L5.60165 12.6122C6.27883 12.7183 6.76243 13.3385 6.71256 14.0373L6.64498 14.9844C6.62529 15.2603 6.77228 15.52 7.01572 15.6402L7.6942 15.9745C7.93765 16.0946 8.22833 16.0496 8.42715 15.8624L9.10892 15.218C9.61155 14.7427 10.3872 14.7427 10.8904 15.218L11.5722 15.8624C11.771 16.0503 12.0611 16.0946 12.3052 15.9745L12.985 15.6395C13.2277 15.52 13.3741 15.2609 13.3544 14.9857L13.2868 14.0373C13.2369 13.3385 13.7205 12.7183 14.3977 12.6122L15.315 12.4686C15.5821 12.427 15.7973 12.2223 15.8577 11.9524L16.025 11.202C16.0854 10.9321 15.9784 10.6522 15.7553 10.4965L14.9896 9.96019C14.4246 9.56416 14.252 8.7909 14.5932 8.18343L15.0559 7.3605C15.1904 7.12087 15.1681 6.82083 14.9994 6.60469L14.5303 6.00259C14.3616 5.78645 14.0808 5.69718 13.8222 5.7784L12.9351 6.05629C12.2796 6.26169 11.5807 5.91734 11.3288 5.26557L10.9889 4.38424C10.8891 4.12649 10.6457 3.95734 10.3747 3.95801L9.62271 3.96002C9.35171 3.96069 9.10892 4.13119 9.0105 4.38961L8.67913 5.26088C8.42978 5.91667 7.72767 6.2637 7.07018 6.05696L6.14628 5.76699C5.88709 5.6851 5.60494 5.77504 5.4363 5.99252L4.97041 6.59529C4.80178 6.81344 4.78143 7.11416 4.91857 7.35379L5.39168 8.17873C5.74011 8.78687 5.5695 9.56752 5.00125 9.96556L4.24468 10.4958C4.02158 10.6522 3.91462 10.9321 3.97499 11.2013L4.14232 11.9517C4.20203 12.2223 4.41726 12.427 4.68432 12.4686Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3259 8.67378C12.058 9.40593 12.058 10.5934 11.3259 11.3256C10.5938 12.0577 9.40627 12.0577 8.67412 11.3256C7.94197 10.5934 7.94197 9.40593 8.67412 8.67378C9.40627 7.94164 10.5938 7.94164 11.3259 8.67378Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsInactive);
export default __webpack_public_path__ + "static/media/SettingsInactive.5f708010969af5dbc4b1706c063256cf.svg";
export { ForwardRef as ReactComponent };